import { takeEvery } from 'redux-saga/effects';

import { applicationInitActions } from './init/init.actions';
import { applicationInitSaga } from './init/init.saga';

export function* applicationMux() {
  yield takeEvery(applicationInitActions.initApplicationRequested, applicationInitSaga);
}
